"use client";

import { useEditorReadOnly } from "platejs/react";
import { cn } from "../../lib/utils";

import { Toolbar } from "./toolbar";

type FixedToolbarProps = React.ComponentProps<typeof Toolbar> & { includeFullscreen: boolean };

export function FixedToolbar({ includeFullscreen, ...props }: FixedToolbarProps) {
  const readOnly = useEditorReadOnly();
  if (!readOnly || includeFullscreen == true)
    return (
      <Toolbar
        {...props}
        className={cn(
          "scrollbar-hide sticky top-0 left-0 z-50 w-full justify-between overflow-x-auto rounded-t-lg border-b border-b-border bg-background/95 p-1 backdrop-blur-sm supports-backdrop-blur:bg-background/60",
          props.className
        )}
      />
    );
}
